module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "boxhos"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "sanyeHos",
    attrs: {
      "href": "javascript:;",
      "data-url": "/#/orderSanye"
    },
    on: {
      "click": function($event) {
        _vm.eve()
      }
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('DownloadApp'), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "colligateHos",
    attrs: {
      "href": "/#/order"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/colli.png"),
      "alt": "",
      "title": "",
      "width": "100%;"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/sanye.png"),
      "alt": "",
      "title": "",
      "width": "100%;"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-8e3a12b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChooseHos.vue
// module id = 200
// module chunks = 1